import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class PriorityService {
    // Get all 
    static async getAllPriorities() {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}`; // endpoint
        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch priorities.');
            return [];
        }
    }

    // Create
    static async addNewPriority(data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}`; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Priority added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new priority.');
        }
    }

    // Get by ID
    static async getPriorityById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch priority by ID');
        }
    }

    // Update 
    static async updatePriorityById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Priority updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update priority.');
        }
    }

    // Delete 
    static async deletePriority(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete priority.');
            }
        } catch (error) {
            console.error('Error deleting priority:', error);
            throw error;
        }
    }

    // Delete many
    static async deleteManyPriorities(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }

    static async getPriorityByType(priorityType) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.PRIORITIES}/type/${priorityType}`;

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
